import React, { useState, useEffect, useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import Masonry from 'react-masonry-css';

import Container from 'react-bootstrap/Container';
import ClipLoader from 'react-spinners/ClipLoader';

import DefaultLayout from '../layouts/DefaultLayout';
import Loader from '../components/Loader';
import { Twig } from '../types';
import { listFollowingTwigs, explorerlistTwigs, listOffers } from '../services/TwigService';
import TwigCard from '../components/TwigCard';
import { useLoadMore } from '../lib/hooks';
import { Helmet } from 'react-helmet';
import { RouteProps } from 'react-router';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Text from '../components/Text';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { RootState } from '../config/store';
import { AuthState } from '../reducers/auth';
import { pageTrack, track } from '../services/mixpanelService';

export interface TwigListingProps extends RouteProps {

  fromDiscover?: boolean,
  history?: any
}


const TwigListing: React.FC<TwigListingProps> = (props) => {
  const { fromDiscover, history } = props;

  const { isAuthenticated, user } = useSelector<RootState, AuthState>(
    (state) => state.auth,
  );

  const [selectedTab, setSelectedTab] = useState('forYou');

  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [myTwigs, setMyTwigs] = useState<Twig[]>([]);
  const [loadingMoreMyTwig, setLoadingMoreMyTwig] = useState(false);
  const [currentPageMyTwig, setCurrentPageMyTwig] = useState(1);
  const [hasMoreMyTwig, setHasMoreMyTwig] = useState(true);
  const [doInfiniteScrollMyTwig, setDoInfiniteScrollMyTwig] = useState(false);




  const [offers, setOffers] = useState<Twig[]>([]);
  const [loadingMoreOffers, setLoadingMoreOffers] = useState(false);
  const [currentPageOffers, setCurrentPageOffers] = useState(1);
  const [hasMoreOffers, setHasMoreOffers] = useState(true);
  const [doInfiniteScrollOffers, setDoInfiniteScrollOffers] = useState(false);


  const [followings, setFollowings] = useState<Twig[]>([]);
  const [loadingMoreFollowings, setLoadingMoreFollowings] = useState(false);
  const [currentPageFollowings, setCurrentPageFollowings] = useState(1);
  const [hasMoreFollowings, setHasMoreFollowings] = useState(true);
  const [doInfiniteScrollFollowings, setDoInfiniteScrollFollowings] = useState(false);

  const endReached = useLoadMore();
  const endReachedOffers = useLoadMore();
  const endReachedFollowing = useLoadMore();




  const changeTab = useCallback((value) => {
    setSelectedTab(value);
    if (value == "following") {
      track("following")
    }
    if (value == "offer") {
      track("offers")
    }
  }, []);


  useEffect(() => {

    (async () => {
      setLoading(true);
      try {
        if (selectedTab == "forYou") {
          var { twigs: response, pagination } = await explorerlistTwigs(1, 10);
          pageTrack("home_screen")

          setMyTwigs(response);
          if(currentPageMyTwig >= pagination.totalPages) {
            setHasMoreMyTwig(false);
          } else {
            setCurrentPageMyTwig(currentPageMyTwig + 1);
          }
          setDoInfiniteScrollMyTwig(true);
        }

      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    })();
  }, []);


  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (selectedTab == "forYou") {
          var { twigs: response, pagination } = await explorerlistTwigs(1, 10);

          setMyTwigs(response);
          if (currentPageMyTwig >= pagination.totalPages) {
            setHasMoreMyTwig(false);
          } else {
            setCurrentPageMyTwig(currentPageMyTwig + 1);
          }
          setDoInfiniteScrollMyTwig(true);
        }
        else if (selectedTab == "offer") {
          var { twigs: response, pagination } = await listOffers(1, 10);

          setOffers(response);
          if (currentPageOffers >= pagination.totalPages) {
            setHasMoreOffers(false);
          } else {
            setCurrentPageOffers(currentPageOffers + 1);
          }
          setDoInfiniteScrollOffers(true);
        }
        else if (selectedTab == "following" && isAuthenticated) {
          var { twigs: response, pagination } = await listFollowingTwigs(1, 10);

          setFollowings(response);
          if (currentPageFollowings >= pagination.totalPages) {
            setHasMoreFollowings(false);
          } else {
            setCurrentPageFollowings(currentPageOffers + 1);
          }
          setDoInfiniteScrollFollowings(true);
        }

      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    })();
  }, [selectedTab, isAuthenticated]);

  // @Todo: refactor this and mrege it with the above one
  useEffect(() => {
    if (!doInfiniteScrollMyTwig || !hasMoreMyTwig || !endReached || loadingMoreMyTwig || selectedTab != 'forYou') return;
    (async () => {
      setLoadingMoreMyTwig(true);
      try {

        // if (fromDiscover) {
        var { twigs: response, pagination } = await explorerlistTwigs(currentPageMyTwig, 10);
        // }
        // else {
        //   console.log(props.location?.search)
        //   var { twigs: response, pagination } = await explorerlistTwigs(currentPageMyTwig, 10, props.location?.search || "");
        //   // var { twigs: response, pagination } = await listTwigs(currentPage, 10);
        // }
        setMyTwigs([...myTwigs, ...response]);
        if (currentPageMyTwig >= pagination.totalPages) {
          setHasMoreMyTwig(false);
        } else {
          setCurrentPageMyTwig(currentPageMyTwig + 1);
        }
      } catch (e) {
        console.error(e);
      }
      setLoadingMoreMyTwig(false);
    })();
  }, [doInfiniteScrollMyTwig, hasMoreMyTwig, currentPageMyTwig, endReached, loadingMoreMyTwig, myTwigs]);


  useEffect(() => {
    if (!doInfiniteScrollOffers || !hasMoreOffers || !endReachedOffers || loadingMoreOffers) return;
    (async () => {
      setLoadingMoreOffers(true);
      try {

        // if (fromDiscover) {
        var { twigs: response, pagination } = await listOffers(currentPageMyTwig, 10);
        // }
        // else {
        //   console.log(props.location?.search)
        //   var { twigs: response, pagination } = await explorerlistTwigs(currentPageMyTwig, 10, props.location?.search || "");
        //   // var { twigs: response, pagination } = await listTwigs(currentPage, 10);
        // }
        setOffers([...offers, ...response]);
        if (currentPageOffers >= pagination.totalPages) {
          setHasMoreOffers(false);
        } else {
          setCurrentPageOffers(currentPageOffers + 1);
        }
      } catch (e) {
        console.error(e);
      }
      setLoadingMoreOffers(false);
    })();
  }, [doInfiniteScrollOffers, hasMoreOffers, currentPageOffers, endReachedOffers, loadingMoreOffers, offers]);



  useEffect(() => {
    if (!doInfiniteScrollFollowings || !hasMoreFollowings || !endReachedFollowing || loadingMoreFollowings) return;
    (async () => {
      setLoadingMoreFollowings(true);
      try {

        // if (fromDiscover) {
        var { twigs: response, pagination } = await listFollowingTwigs(currentPageFollowings, 10);
        // }
        // else {
        //   console.log(props.location?.search)
        //   var { twigs: response, pagination } = await explorerlistTwigs(currentPageMyTwig, 10, props.location?.search || "");
        //   // var { twigs: response, pagination } = await listTwigs(currentPage, 10);
        // }
        setFollowings([...followings, ...response]);
        if (currentPageFollowings >= pagination.totalPages) {
          setHasMoreFollowings(false);
        } else {
          setCurrentPageFollowings(currentPageFollowings + 1);
        }
      } catch (e) {
        console.error(e);
      }
      setLoadingMoreFollowings(false);
    })();
  }, [doInfiniteScrollFollowings, hasMoreFollowings, currentPageFollowings, endReachedFollowing, loadingMoreFollowings, followings]);


  const children = (
    <Loader className={classes.loader} center loading={loading}>
      {() => (
        <>
          <Row>
            <Col xs={12}>
              <div className={classes.tabs}>
                <div className={clsx(classes.oneTab, selectedTab == 'following' ? classes.oneTabActive : "")}
                  onClick={() =>
                    changeTab('following')
                  }
                >
                  <Text as="span">Following
                  </Text>
                  {
                    selectedTab == 'following' ?
                      <div className={classes.circleActive}></div>
                      : null
                  }
                </div>
                <div className={clsx(classes.oneTab, selectedTab == 'forYou' ? classes.oneTabActive : "")}
                  onClick={() =>
                    changeTab('forYou')
                  }
                >
                  <Text as="span">For You</Text>
                  {
                    selectedTab == 'forYou' ?
                      <div className={classes.circleActive}></div>
                      : null
                  }

                </div>
                <div className={clsx(classes.oneTab, selectedTab == 'offer' ? classes.oneTabActive : "")}
                  onClick={() =>
                    changeTab('offer')
                  }
                >
                  <Text as="span">Offer</Text>
                  {
                    selectedTab == 'offer' ?
                      <div className={classes.circleActive}></div>
                      : null
                  }

                </div>
              </div>
            </Col>
          </Row>
          {
            selectedTab == 'offer' ?
              <Masonry
                breakpointCols={{
                  default: 3, 1100: 2, 700: 1,
                  500: 1
                }}
                columnClassName=""
                className={classes.wrapper}
              >
                {offers.map((twig) => (
                  <div key={twig.id} className={classes.twigWrapper}>
                    <TwigCard twig={twig} />
                  </div>
                ))}
              </Masonry> :
              selectedTab == 'forYou' ?
                <Masonry
                  breakpointCols={{
                    default: 3, 1100: 2, 700: 1,
                    500: 1
                  }}
                  columnClassName=""
                  className={classes.wrapper}
                >
                  {myTwigs.map((twig) => (
                    <div key={twig.id} className={classes.twigWrapper}>
                      <TwigCard twig={twig} />
                    </div>
                  ))}
                </Masonry> :
                isAuthenticated ?
                  <Masonry
                    breakpointCols={{
                      default: 3, 1100: 2, 700: 1,
                      500: 1
                    }}
                    columnClassName=""
                    className={classes.wrapper}
                  >
                    {followings.map((twig) => (
                      <div key={twig.id} className={classes.twigWrapper}>
                        <TwigCard twig={twig} />
                      </div>
                    ))}
                  </Masonry>
                  :
                  <Text as="h4" align="center" color="primary" bold> Pleas signin to continue </Text>
          }


          {
            loadingMoreFollowings || loadingMoreMyTwig || loadingMoreOffers ?
              <div className={classes.loadingMoreBox}>
                <ClipLoader color="#522583" />
              </div>
              : null
          }
          {/* <Masonry
            breakpointCols={{
              default: 3, 1100: 2, 700: 1,
              500: 1
            }}
            columnClassName=""
            className={classes.wrapper}
          >
            {twigs.map((twig) => (
              <div key={twig.id} className={classes.twigWrapper}>
                <TwigCard twig={twig} />
              </div>
            ))}
          </Masonry>
          <div className={classes.loadingMoreBox}>
            {loadingMore ? <ClipLoader color="#522583" /> : null}
          </div> */}
        </>
      )}
    </Loader>
  )
  return (
    <>

      {
        !fromDiscover ? (
          <Helmet>
            <title> twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
             
          </Helmet>
        ) : null
      }
      
      {
        !fromDiscover ? (
          <DefaultLayout history={history}>
            <Container className="pt-3" fluid>
              {children}
            </Container>
          </DefaultLayout>
        ) : children
      }
    </>
  );
};

const useStyles = createUseStyles({
  loader: {
    minHeight: '70vh',
  },
  wrapper: {
    display: 'flex',
    width: 'auto',
  },
  twigWrapper: {
    margin: '1rem',
    position: 'relative'

  },
  loadingMoreBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
  },
  tabs: {

    justifyContent: "center",
    display: "flex"
  },
  oneTab: {
    margin: "5px 15px",
    "&:hover": {
      cursor: 'pointer'
    }
  },
  oneTabActive: {
    fontWeight: 'bold'
  },
  circleActive: {
    width: '8px',
    height: '8px',
    backgroundColor: '#522583',
    borderRadius: '50%',
    margin: '0px auto'
  }

});

export default TwigListing;
